import { CustomerBalanceRequest } from "./customer-balance-request";

export class CustomerDetailRequest {
    customerId?: number;
    balanceRequest?: CustomerBalanceRequest;
}